import { render, staticRenderFns } from "./icon-workplace.vue?vue&type=template&id=1793b590&scoped=true"
var script = {}
import style0 from "./icon-workplace.vue?vue&type=style&index=0&id=1793b590&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1793b590",
  null
  
)

export default component.exports